import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { List } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import api from "../../api/api";
import SearchBox from "../SearchBox/SearchBox";
import MenuItems from "./MenuItems";
import "./SideMenu.scss";

const SideMenu = (props) => {
  const manualType = useSelector((state) => state.manualTypeChecker.manualType);
  const platformType = useSelector(
    (state) => state.platformTypeChecker.platformType,
  );

  const [menuData, setMenuData] = useState();
  const [toggleMenu, setToggleMenu] = useState(false);

  const menuBar = useRef();

  useEffect(() => {
    axios
      .get(api.snb.select)
      .then((res) => {
        setMenuData([...res.data.custom, ...res.data.cms]);
      })
      .catch((e) => {
        alert(e.response.data.message);
        console.log(e);
      });
  }, [manualType, props.offset, platformType]);

  const handleToggleMenu = () => {
    // 모바일 화면에서 햄버거 버튼을 통한 lnb 토글
    setToggleMenu(!toggleMenu);
  };

  return (
    <>
      <div
        className={`menubar component-menubar ${
          toggleMenu ? "menubar-active" : ""
        }`}
        style={{ transition: "left 0.3s ease-in-out" }}
        ref={menuBar}
      >
        <List
          className="menu-toggle"
          color="white"
          size={25}
          onClick={handleToggleMenu}
        />
        <SearchBox />
        {/* <MultiMenus menus={menuData} menubar={menuBar} /> */}
        <MenuItems menus={menuData} />
        <div className="component-blank" />
      </div>
    </>
  );
};

export default SideMenu;
